import React from 'react'

const SslIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 4.5C3.67157 4.5 3 5.17157 3 6V12C3 12.8284 3.67157 13.5 4.5 13.5H11.5C12.3284 13.5 13 12.8284 13 12V6C13 5.17157 12.3284 4.5 11.5 4.5V4C11.5 2.067 9.933 0.5 8 0.5C6.067 0.5 4.5 2.067 4.5 4L4.5 4.5ZM6 4.5H10V4C10 2.89543 9.10457 2 8 2C6.89543 2 6 2.89543 6 4V4.5Z"
      fill="#74DF8B"
    />
  </svg>
)

export default SslIcon
